module.exports = __webpack_public_path__ + "static/img/alpaga-thumb.b3f7b11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alpaga-thumb.jpg
// module id = 29
// module chunks = 0